import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://r6collective.com';

const PageSEO = ({ title, description, path = '', type = 'website', image }) => {
  const fullUrl = `${BASE_URL}${path}`;
  const fullTitle = title ? `${title} | The R6 Collective` : 'The R6 Collective | Enterprise-Level Talent Solutions';
  const ogImage = image || 'https://customer-assets.emergentagent.com/job_collective-build-1/artifacts/i8zwnurb_iStock-2190572410.jpg';

  return (
    <Helmet
      title={fullTitle}
      meta={[
        { name: 'description', content: description },
        { property: 'og:title', content: fullTitle },
        { property: 'og:description', content: description },
        { property: 'og:url', content: fullUrl },
        { property: 'og:type', content: type },
        { property: 'og:image', content: ogImage },
        { name: 'twitter:title', content: fullTitle },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: ogImage },
      ]}
      link={[
        { rel: 'canonical', href: fullUrl },
      ]}
    />
  );
};

export default PageSEO;
